import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import Breadcrumbs from "@components/Breadcrumbs/Breadcrumbs";
import Pagination from "@components/Pagination/Pagination";
import { animations } from "react-animation";
import { cleanValue } from "@helpers/utils.js";
import "./FindResult.css";
import { isUndefined } from "lodash";

const PageSize = 5;

function FindResult(props) {
  const [results, setResults] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const hostAC = process.env.REACT_APP_HOST;
  const hostGCS = process.env.REACT_APP_HOST_GRUPO_CS;
  const hostCSCS = process.env.REACT_APP_HOST_CS_CORREDORA_SEGUROS;
  const hostNH = process.env.REACT_APP_HOST_NOVAHUB;

  const { rutas } = useSelector(({ Base }) => Base.ContenidoCMS);
  const { lastSearchCriteria } = useSelector(({ findBar }) => findBar.search);

  const filteredResults = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return results?.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, results]);

  const startData = () => {
    if (!isUndefined(lastSearchCriteria)) {
      getFilteredData(rutas, "keywords", lastSearchCriteria).then((bulk) => {
        let matches = bulk?.map((itemBulk) => {
          return (itemBulk.status = "fulfilled" && itemBulk.value);
        });

        let grossResults = [];

        matches?.forEach((match) => {
          match.forEach((item) => {
            grossResults.push(item);
          });
        });

        const dataArr = new Set(grossResults);
        let bulkDataResult = [...dataArr];
        let filteredData = bulkDataResult.filter(
          (res) => !res?.url?.includes(":")
        );
        setResults(filteredData);
      });
    }
  };

  useEffect(() => {
    if (!isUndefined(lastSearchCriteria)) {
      startData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isUndefined(lastSearchCriteria)) {
      startData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lastSearchCriteria]);

  async function getFilteredData(arr, field, value) {
    try {
      value = cleanValue(value);
      let promises = value.map((val) => {
        let promise = new Promise((resolve, reject) => {
          let f = arr.filter((fld) =>
            fld[field].toLowerCase().includes(val.toLocaleLowerCase())
          );
          resolve(f);
        });

        let result = promise;
        return result;
      });
      const statusesPromise = await Promise.allSettled(promises);
      return statusesPromise;
    } catch (err) {
      //alert(err)
    }
  }

  const checkHost = (siteId) => {
    switch (siteId) {
      case "AC":
        return hostAC;
      case "GCS":
        return hostGCS;
      case "COR":
        return hostCSCS;
      case "NH":
        return hostNH;
      default:
        return hostAC;
    }
  };

  return (
    <div style={{ animation: animations.fadeIn }}>
      <Breadcrumbs items={[]} active="Resultados de Búsqueda" />
      <div className="result_main_container">
        <div className="result_head mt-3 mb-4 ms-5 me-5">
          Resultados de Búsqueda
        </div>
        <div className="d-flex justify-content-between shadow-lg p-3 mb-5 ms-5 me-5 bg-body rounded result_content">
          <div
            className="d-flex flex-fill flex-column align-items-start"
            style={{ animation: animations.fadeIn }}
          >
            {results.length > 0 ? (
              filteredResults.map((res, index) => {
                return (
                  <div key={index} style={{ animation: animations.fadeIn }}>
                    <a href={checkHost(res?.identificadorSitio) + res?.url}>
                      <h3 className="result_title d-flex align-items-start">
                        {res.title}
                      </h3>
                    </a>
                    <a href={checkHost(res?.identificadorSitio) + res?.url}>
                      <h4 className="result_link d-flex align-items-start">
                        {checkHost(res?.identificadorSitio) + res?.url}
                      </h4>
                    </a>
                    <p>{res.description}</p>
                  </div>
                );
              })
            ) : (
              <div>No se encontraron coincidencias.</div>
            )}
          </div>
        </div>
        {results.length > PageSize && (
          <div className="shadow-lg p-3 mb-5 ms-5 me-5 bg-body rounded result_paginador">
            <Pagination
              className="pagination-bar"
              currentPage={currentPage}
              totalCount={results.length}
              pageSize={PageSize}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default FindResult;
